import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const PORTAL = axios.create({ baseURL: '/api/portal', timeout: 20000 });

// attach customer token + identify this client to the backend (registration
// and any future analytics need to tell "customer used the website" apart
// from "customer used the app" — see routes/portal.js's /register handler
// and customers.registration_source).
PORTAL.interceptors.request.use(cfg => {
  const t = localStorage.getItem('sf_customer_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.headers['X-Client-Platform'] = 'web';
  return cfg;
});

const AuthCtx = createContext(null);
export const usePortal = () => useContext(AuthCtx);
export { PORTAL };

export function PortalAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [ready, setReady] = useState(false);
  const [cart, setCart] = useState({ items: [], count: 0, total: 0 });
  const [wishlist, setWishlist] = useState({ items: [], count: 0 });
  const [compare, setCompare] = useState({ items: [], count: 0, max: 4 });

  const refreshCart = useCallback(() => {
    if (!localStorage.getItem('sf_customer_token')) return;
    PORTAL.get('/cart').then(r => setCart(r.data)).catch(() => {});
  }, []);
  const refreshWishlist = useCallback(() => {
    if (!localStorage.getItem('sf_customer_token')) return;
    PORTAL.get('/wishlist').then(r => setWishlist(r.data)).catch(() => {});
  }, []);
  const refreshCompare = useCallback(() => {
    if (!localStorage.getItem('sf_customer_token')) return;
    PORTAL.get('/compare').then(r => setCompare(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (localStorage.getItem('sf_customer_token')) {
      PORTAL.get('/me')
        .then(r => { setCustomer(r.data.customer); refreshCart(); refreshWishlist(); refreshCompare(); })
        .catch(() => localStorage.removeItem('sf_customer_token'))
        .finally(() => setReady(true));
    } else setReady(true);
  }, [refreshCart, refreshWishlist, refreshCompare]);

  const login = (token, cust) => {
    localStorage.setItem('sf_customer_token', token);
    setCustomer(cust);
    refreshCart();
    refreshWishlist();
    refreshCompare();
  };
  const logout = () => {
    localStorage.removeItem('sf_customer_token');
    setCustomer(null);
    setCart({ items: [], count: 0, total: 0 });
    setWishlist({ items: [], count: 0 });
    setCompare({ items: [], count: 0, max: 4 });
  };

  return (
    <AuthCtx.Provider value={{
      customer, setCustomer, ready, cart, setCart, refreshCart,
      wishlist, setWishlist, refreshWishlist,
      compare, setCompare, refreshCompare,
      login, logout,
    }}>
      {children}
    </AuthCtx.Provider>
  );
}
